import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { ApplicationState } from "../store";
import { TimelineState } from "../store/timeline/types";


interface Props {

}

const PlaybackPlayer: React.FC<Props> = () => {
    const dispatch = useDispatch();
    const { playbackMode, time } = useSelector<ApplicationState, TimelineState>(state => state.timeline);

    useEffect(() => {
        if (playbackMode !== 'pause') {
            const direction =  playbackMode === 'play' ? 1 : -1;
            dispatch({type: 'runPlayback', direction});
        }
    }, [playbackMode, time]);

    return null
};


export default PlaybackPlayer